import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Table, Input, Button, Space, Select, DatePicker, Rate } from "antd";
import { useParams } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import moment from "moment/moment";

function Task() {
  const initialDate = moment(new Date());
  const { id } = useParams();
  const [task, setTask] = useState({});
  const [scores, setScores] = useState([]);
  const [classrooms, setClassrooms] = useState([]);
  const [classId, setClassId] = useState(0);
  const [scenarioId, setScenarioId] = useState(0);
  const [scenarios, setScenarios] = useState([]);
  const [desc, setDesc] = useState("");
  const [deadline, setDeadline] = useState("");
  const [title, setTitle] = useState("");
  const [formattedDate, setFormattedDate] = useState(moment(new Date()));

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .get("http://78.186.196.90:8091/Task/Get?Id=" + id)
        .then((response) => {
          setTask(response.data.value.task);
          setScores(response.data.value.score);
          setDeadline(response.data.value.task.lastDate);
          setClassId(response.data.value.task.classId);
          setScenarioId(response.data.value.task.scenarioId);
          setTitle(response.data.value.task.title);
          setDesc(response.data.value.task.description);
        })
        .catch((e) => {
          console.log(e);
        });
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "http://78.186.196.90:8091/Scenario/GetAll"
      );
      setScenarios(response.data.scenarios);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const fetchData = async () => {
      const response = await axios.get(
        "http://78.186.196.90:8091/ClassRoom/GetAll?TeacherId=" + user.id
      );
      setClassrooms(response.data);
    };
    fetchData();
  }, []);

  const onChange = (date, dateString) => {
    console.log(date, dateString);
    setDeadline(dateString);
  };

  const handleChangeTitle = (e) => {
    setTitle(e.currentTarget.value);
  };

  const handleChangeDesc = (e) => {
    setDesc(e.currentTarget.value);
  };

  const handleChangeClass = (value) => {
    setClassId(value);
  };

  const handleChangeScneario = (value) => {
    setScenarioId(value);
  };
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      className: "text-xs",
      defaultSortOrder: "ascend",
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      sorter: (a, b) => a.id - b.id,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Name",
      dataIndex: "user",
      defaultSortOrder: "ascend",
      className: "capitalize",
      render: (text, record) => {
        return text == "" ? "Noname" : text;
      },
      sorter: (a, b) => a.name > b.name,
    },

    {
      title: "Score",
      dataIndex: "score",
      defaultSortOrder: "descend",
      render: (_, { avarageScore, scoreNumber }) => (
        <>
          <Rate disabled count={3} defaultValue={avarageScore} />
          <div>Score:{scoreNumber.toFixed(0)}</div>
        </>
      ),
      sorter: (a, b) => a.score - b.score,
    },
  ];

  const handleSave = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    axios
      .post("http://78.186.196.90:8091/Task/Add", {
        id: id,
        teacherId: user.id,
        title: title,
        description: desc,
        scenarioId: scenarios[0].id,
        scenarioName: scenarios[0].title,
        classId: classrooms[0].id,
        classTitle: classrooms[0].title,
        lastDate: deadline,
      })
      .then(function (response) {
        console.log(response);
        window.location.href = "http://78.186.196.90:8181/Tasks";
      })
      .catch(function (error) {});
  };

  const onChangeTable = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  return (
    <>
      <main>
        <header>
          <div className="flex-row">
            <h1>{task.title}</h1>
            {user.role === "teacher" && (
              <Button type="primary" onClick={handleSave}>
                Save
              </Button>
            )}
          </div>
        </header>

        <div className="flex-row flex-start">
          <section className="one-third">
            <header>
              <h2>Task</h2>
            </header>
            <div>
              <label className="label">Classrooms</label>
              <Select
                className="input"
                options={
                  classrooms &&
                  classrooms.map((item) => {
                    return {
                      value: item.id,
                      label: item.title,
                    };
                  })
                }
                onChange={handleChangeClass}
                value={classId}
              />
            </div>
            <div>
              <label className="label">Scenarios</label>
              <Select
                className="input"
                options={
                  scenarios &&
                  scenarios.map((item) => {
                    return {
                      value: item.id,
                      label: item.title,
                    };
                  })
                }
                onChange={handleChangeScneario}
                value={scenarioId}
              />
            </div>
            <div>
              <label className="label">Title</label>
              <Input
                placeholder=""
                onChange={handleChangeTitle}
                className="input"
                value={title}
              />
            </div>
            <div>
              <label className="label">Description</label>
              <TextArea
                rows={4}
                placeholder=""
                onChange={handleChangeDesc}
                className="input"
                value={desc}
              />
            </div>
            {id == 0 && (
              <div>
                <label className="label">Deadline</label>
                <DatePicker onChange={onChange} className="input" />
              </div>
            )}
          </section>
          <section className="two-third">
            <header>
              <h2>Scores</h2>
            </header>
            <Table
              rowKey="id"
              columns={columns}
              dataSource={scores.slice(5)}
              rowClassName="table-row"
              onChange={onChangeTable}
              showSorterTooltip={{
                target: "sorter-icon",
              }}
            />
          </section>
        </div>
      </main>
    </>
  );
}

export default Task;
